/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_RecommendedInputs */

const zh_subscription_recommended = /** @type {(inputs: Subscription_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐`)
};

const en_subscription_recommended = /** @type {(inputs: Subscription_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

const es_subscription_recommended = /** @type {(inputs: Subscription_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomendado`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Subscription_RecommendedInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const subscription_recommended = /** @type {((inputs?: Subscription_RecommendedInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_RecommendedInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_recommended(inputs)
	if (locale === "en") return en_subscription_recommended(inputs)
	return es_subscription_recommended(inputs)
});